import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Breadcrumbs from '../navigation/Breadcrumbs';
import { buildServiceBreadcrumbs } from '../navigation/breadcrumbUtils';
import './IoTIntegration.css';

const IoTIntegration = () => {
  const location = useLocation();
  const servicesIndexView = location.state?.servicesIndexView;
  const backPath = servicesIndexView ? '/services' : '/';

  return (
    <div className="iot-integration-page-wrapper">
      <div className="iot-integration-page-container">
        <Breadcrumbs
          items={buildServiceBreadcrumbs('services', 'IoT Integration')}
        />

        <div className="iot-integration-back-link">
          <Link
            to={backPath}
            state={servicesIndexView ? { servicesIndexView } : undefined}
          >
            {servicesIndexView ? '\u2190 Back' : '\u2190 Back to Home'}
          </Link>
        </div>

        <div className="iot-integration-page-hero">
          <h1>IoT Integration Services</h1>
          <p>
            BlackRoth provides end-to-end IoT Integration services that connect
            devices, systems, and platforms to enable real-time data exchange,
            automation, and intelligent decision-making.
          </p>
        </div>

        <section className="iot-integration-page-section">
          <h2>Overview</h2>
          <p>
            IoT Integration bridges physical devices with digital platforms.
            BlackRoth designs and implements secure, scalable IoT ecosystems
            that enable seamless communication between sensors, gateways,
            applications, and cloud services.
          </p>
        </section>

        <section className="iot-integration-page-section">
          <h2>Core Capabilities</h2>
          <p>
            Our IoT solutions are built to handle complex device networks,
            large-scale data streams, and enterprise integration requirements
            while ensuring reliability and performance.
          </p>
        </section>

        <section className="iot-integration-page-section">
          <h2>Services We Offer</h2>
          <ul className="iot-integration-service-list">
            <li>IoT Architecture Design & Consulting</li>
            <li>Device & Sensor Integration</li>
            <li>Gateway & Protocol Management</li>
            <li>Real-Time Data Collection & Processing</li>
            <li>Cloud & Edge IoT Integration</li>
            <li>IoT Application Development</li>
            <li>Device Monitoring & Remote Management</li>
            <li>Security, Compliance & Optimization</li>
          </ul>
        </section>

        <section className="iot-integration-page-section">
          <h2>Industry Use Cases</h2>
          <p>
            BlackRoth's IoT Integration services are used across smart cities,
            manufacturing, healthcare, energy, logistics, agriculture, and
            retail to enable automation, predictive insights, and operational
            efficiency.
          </p>
        </section>

        <section className="iot-integration-page-section">
          <h2>Technology Stack</h2>
          <p>
            We work with industry-standard IoT technologies including MQTT,
            REST APIs, cloud IoT platforms, edge gateways, real-time databases,
            and secure communication protocols.
          </p>
        </section>

        <section className="iot-integration-page-section">
          <h2>Security & Reliability</h2>
          <p>
            BlackRoth ensures secure device onboarding, encrypted data
            transmission, access control, and compliance with enterprise
            security standards across the IoT lifecycle.
          </p>
        </section>
      </div>
    </div>
  );
};

export default IoTIntegration;

